import React, { useState, useEffect, isValidElement } from 'react';
import { Helmet } from 'react-helmet-async';

function documentReady(_passThrough) {
  if (document.readyState === "loading") {
    return new Promise((resolve) => {
      document.addEventListener("DOMContentLoaded", () => resolve(_passThrough));
    });
  }
  return Promise.resolve(_passThrough);
}

function Head(props) {
  return /* @__PURE__ */ React.createElement(Helmet, { ...props });
}

function useIsClient() {
  const [isBrowser, setIsBrowser] = useState(false);
  useEffect(() => {
    setIsBrowser(true);
  }, []);
  return isBrowser;
}

function ClientOnly({
  children,
  fallback
}) {
  const isBrowser = useIsClient();
  if (isBrowser) {
    if (typeof children !== "function" && process.env.NODE_ENV === "development") {
      throw new Error(
        `vite-react-ssg error: The children of <ClientOnly> must be a "render function", e.g. <ClientOnly>{() => <span>{window.location.href}</span>}</ClientOnly>.
Current type: ${isValidElement(children) ? "React element" : typeof children}`
      );
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children?.());
  }
  return fallback ?? null;
}

export { ClientOnly as C, Head as H, documentReady as d };
